// Entry-point marker. FSW's staff portal links to the app as `…/?idp=fsw-portal`; the user is already
// authenticated there, so the alias is forwarded to Keycloak as `kc_idp_hint` and the provider chooser
// is skipped. Read straight off window.location: AuthGuard sits above RouterProvider (no router hooks)
// and receives only its children (no AppConfig). Kept free of imports so sanitizedCurrentUrl can take
// the param name from here without an import cycle.

// Our own marker on the entry URL.
export const IDP_HINT_PARAM = "idp";

// Keycloak's parameter for pre-selecting a brokered identity provider.
export const KC_IDP_HINT_PARAM = "kc_idp_hint";

// The identity provider brokered by the staff realm `so`.
export const FSW_PORTAL_IDP_ALIAS = "fsw-portal";

// The marker, but only when it names the provider the calling app actually brokers to. Which provider
// that is belongs to the app, not here: an identity provider is a realm-level object, and the portal
// realm deliberately has none (ADR-0017), so the portal app permits no alias at all. Deliberately an
// exact match rather than a shape check — anything else, an empty value included, counts as no marker
// and lands the user on the normal login page.
export function readIdpHint(permittedAlias: string, search: string = window.location.search): string | null {
  const value = new URLSearchParams(search).get(IDP_HINT_PARAM);
  return value === permittedAlias ? value : null;
}

// The `extraQueryParams` for signinRedirect: undefined without a marker, so the authorization request
// stays exactly as it is for a user who opened the app directly.
export function idpHintQueryParams(hint: string | null): { kc_idp_hint: string } | undefined {
  return hint === null ? undefined : { [KC_IDP_HINT_PARAM]: hint };
}
